{
  "pageSize": 15,
  "filterable": "menu",
  "defaultDateOperator": "eq",
  "defaultSortColumn": "true",
  "defaultColumnWidth": 150,
    "columnsPerRow": 1
}
